import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core'
import { Clipboard } from '@angular/cdk/clipboard'
import { firstValueFrom } from 'rxjs'

import { TranslateModule } from '@ngx-translate/core'
import { MatButtonModule } from '@angular/material/button'
import { GbDashboardSharedUiModule } from 'libs/gb-dashboard/shared/ui/src/lib/gb-dashboard-shared-ui.module'
import { IconLibrary } from 'libs/gb-dashboard/shared/ui/src/lib/gb-icon/gb-icon-library.models'
import { MatMenuModule } from '@angular/material/menu'
import { ProjectorContainersFacade } from 'libs/gb-dashboard/presenter/data-access-projector-containers/src/lib/+state/projector-containers.facade'
import * as ProjectorContainerActions from 'libs/gb-dashboard/presenter/data-access-projector-containers/src/lib/+state/projector-containers.actions'
import { GbNotificationService } from '@galabid/shared/utils/notification'
import { SelectedAuctionFacade } from 'libs/gb-dashboard/auctions/data-access-selected-auction/src/lib/+state/selected-auction.facade'
import { PresenterConstants } from '../presenter.constants'
import { ProjectorsFacade } from 'libs/gb-dashboard/projector/data-access/src/lib/+state/projectors.facade'
import { ProjectorTemplatesFacade } from 'libs/gb-dashboard/presenter/data-access-projector-templates/src/lib/+state/projector-templates.facade'
import * as ProjectorTemplatesActions from 'libs/gb-dashboard/presenter/data-access-projector-templates/src/lib/+state/projector-templates.actions'

@Component({
  selector: 'gb-presenter-preview',
  imports: [TranslateModule, MatButtonModule, GbDashboardSharedUiModule, MatMenuModule],
  templateUrl: './gb-presenter-preview.component.html',
  styleUrl: './gb-presenter-preview.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GbPresenterPreviewComponent {
  IconLibrary = IconLibrary

  @Output() preview = new EventEmitter<void>()

  constructor(
    private projectorContainersFacade: ProjectorContainersFacade,
    private selectedAuctionFacade: SelectedAuctionFacade,
    private projectorsFacade: ProjectorsFacade,
    private projectorTemplatesFacade: ProjectorTemplatesFacade,
    private gbNotificationService: GbNotificationService,
    private clipboard: Clipboard,
  ) {}

  launch() {
    this.projectorContainersFacade.dispatch(ProjectorContainerActions.launchPresenter({}))
  }

  async copyLink() {
    const urlName = await firstValueFrom(this.selectedAuctionFacade.urlName$)
    const selectedProjectorContainer = await firstValueFrom(this.projectorContainersFacade.selectedProjectorContainer$)
    const uuid = selectedProjectorContainer?.uuid
    const path = `/${PresenterConstants.PRESENTER}/${urlName}/${uuid}/${PresenterConstants.VIEW}`
    const fullUrl = `${window.location.origin}${path}`
    this.clipboard.copy(fullUrl)
    this.gbNotificationService.success('PRESENTER.LINK_COPIED')
  }

  presenterView() {
    this.gbNotificationService.message('TODO - GB-11443')
  }

  async saveAsTemplate(): Promise<void> {
    const projectorUuid = await firstValueFrom(this.projectorsFacade.selectedProjectorId$)

    if (!projectorUuid) {
      this.gbNotificationService.error('PRESENTER.NO_SLIDE_SELECTED')
      return
    }

    this.projectorTemplatesFacade.dispatch(
      ProjectorTemplatesActions.openSaveProjectorAsTemplateDialog({ projectorUuid }),
    )
  }
}
